import { isEmpty } from 'lodash';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getPropertyManagerAPI, PropertyManager } from '../api/adserver';
import { RootState } from './rootReducer';
import { AppThunk } from './store';

interface PropertyManagerState {
  loading: boolean;
  isSucess: boolean;
  errMsg: string | null;
  data: PropertyManager | null;
}

const initialState: PropertyManagerState = {
  loading: true,
  isSucess: false,
  errMsg: null,
  data: null,
};

const propertyManagerSlice = createSlice({
  name: 'PropertyManager',
  initialState,
  reducers: {
    fetchPropertyManagerProcessing(state) {
      return { ...state, loading: true };
    },
    fetchPropertyManagerSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        isSucess: true,
        errMsg: null,
      };
    },
    fetchPropertyManagerFailed(state, action: PayloadAction<string>) {
      return { ...state, loading: false, errMsg: action.payload, data: null };
    },
  },
});

export const {
  fetchPropertyManagerProcessing,
  fetchPropertyManagerSuccess,
  fetchPropertyManagerFailed,
} = propertyManagerSlice.actions;

export const selectPropertyManager = createSelector(
  (state: RootState) => state.propertyManager,
  (propertyManagerState: PropertyManagerState) => {
    return {
      ...propertyManagerState,
    };
  },
);

export const getPropertyManager = (): AppThunk => async (dispatch) => {
  try {
    dispatch(fetchPropertyManagerProcessing());
    const data = await getPropertyManagerAPI();
    if (!isEmpty(data)) {
      console.log(`get property manager: ${data.name}`);
      dispatch(fetchPropertyManagerSuccess(data));
    } else {
      dispatch(fetchPropertyManagerSuccess(null));
    }
  } catch (err: any) {
    dispatch(fetchPropertyManagerFailed(err.toString()));
  }
};

export default propertyManagerSlice.reducer;
